package com.appsyde.shared.modules.auth.domain.usecase

import com.appsyde.shared.modules.auth.domain.model.DomainResult
import com.appsyde.shared.modules.auth.domain.repo.AuthRepository

class CheckUserSessionUseCase(
    private val repository: AuthRepository
) {
    suspend operator fun invoke(): DomainResult<Boolean> =
        repository.checkSession()
}
